import './EventPages.scss'
import React from 'react'
import {
  NavLink,
  Route,
  Switch,
  Redirect,
  withRouter,
  useHistory,
  useRouteMatch
} from 'react-router-dom'

import { ExtendedLandingPagesContext } from 'components/Contexts/ExtendedLandingPagesProdiver'

import Button from 'components/Button'
import ExtendedLandingPage from 'components/ExtendedLandingPages/ExtendedLandingPage'
import EditExtendedLandingPagesModal from 'components/ExtendedLandingPages/EditExtendedLandingPagesModal'

import { useTranslation } from 'react-i18next'

const ConfigureIcon = () => (
  <svg
    className="HomeIcon"
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5649 10.9505L19.1646 11.5982C19.2263 11.6651 19.297 11.7357 19.3706 11.8093C19.7195 12.1579 20.1339 12.572 19.9622 12.9616L19.1326 14.9606C18.9659 15.3658 18.3679 15.3621 17.8725 15.359C17.774 15.3584 17.6795 15.3578 17.5934 15.3604L16.7098 15.3884C16.3144 15.8789 15.8666 16.3246 15.3744 16.7178L15.3444 17.6014C15.3414 17.6893 15.3417 17.7855 15.342 17.8856C15.3436 18.3817 15.3455 18.9743 14.9446 19.1406L12.9456 19.9622C12.543 20.1293 12.125 19.7086 11.7757 19.357C11.707 19.2879 11.6409 19.2214 11.5782 19.1626L10.9345 18.5629C10.3088 18.6327 9.67717 18.6327 9.05141 18.5629L8.40371 19.1626C8.33797 19.2232 8.26839 19.2927 8.19579 19.3653C7.84895 19.7119 7.43309 20.1275 7.03636 19.9622L5.03731 19.1326C4.63209 18.9659 4.63584 18.3679 4.63894 17.8725C4.63956 17.774 4.64015 17.6795 4.6375 17.5934L4.61151 16.7118C4.12035 16.3165 3.67391 15.8687 3.28014 15.3764L2.39856 15.3464C2.31094 15.3434 2.21499 15.3437 2.11501 15.344C1.61963 15.3456 1.02563 15.3475 0.859289 14.9466L0.0376784 12.9476C-0.129383 12.5449 0.292727 12.1256 0.643622 11.7769C0.712606 11.7084 0.778838 11.6426 0.837299 11.5802L1.43702 10.9365C1.36692 10.3094 1.36692 9.67649 1.43702 9.04941L0.837299 8.40371C0.776745 8.33797 0.707205 8.26839 0.634643 8.19579C0.288003 7.84895 -0.127624 7.43309 0.0376784 7.03636L0.867285 5.03731C1.03404 4.6321 1.6306 4.63584 2.12556 4.63894C2.22397 4.63956 2.31836 4.64015 2.40456 4.6375L3.28814 4.60951C3.68286 4.11916 4.12997 3.67339 4.62151 3.28014L4.65349 2.39656C4.65694 2.30693 4.65676 2.20845 4.65657 2.1058C4.65568 1.61319 4.65461 1.02472 5.0533 0.859289L7.05235 0.0376784C7.45557 -0.129632 7.87699 0.293986 8.22638 0.645189C8.29444 0.713609 8.35977 0.779281 8.4217 0.837299L9.0634 1.43702C9.69048 1.36692 10.3234 1.36692 10.9505 1.43702L11.5962 0.837299C11.6615 0.777157 11.7306 0.708153 11.8028 0.636127C12.1504 0.28919 12.5683 -0.12786 12.9656 0.0376784L14.9646 0.867285C15.3698 1.03404 15.3661 1.63061 15.363 2.12557C15.3624 2.22397 15.3618 2.31836 15.3644 2.40456L15.3924 3.29014C15.8819 3.68435 16.327 4.13078 16.7198 4.62151L17.6054 4.65349C17.693 4.65651 17.7889 4.65621 17.8888 4.65589C18.3837 4.65432 18.9763 4.65243 19.1426 5.0533L19.9642 7.05235C20.1315 7.45556 19.7093 7.87558 19.3574 8.22567C19.2889 8.29388 19.223 8.35944 19.1646 8.4217L18.5649 9.0654C18.6348 9.69182 18.6348 10.3241 18.5649 10.9505ZM5.44112 9.99896C5.44112 12.6157 7.49015 14.7367 10.0209 14.7367C12.5517 14.7367 14.6008 12.6157 14.6008 9.99896C14.6008 7.3822 12.5517 5.2612 10.0209 5.2612C7.49015 5.2612 5.44112 7.3822 5.44112 9.99896Z"
    />
  </svg>
)

const MenuItem = ({ to, children }) => (
  <NavLink activeClassName="active" className="MenuItem" to={to}>
    {children}
  </NavLink>
)

const EventPages = ({ id }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const match = useRouteMatch('/event/:eventId/pages/:pageId')

  const { website, fetchWebsite } = React.useContext(
    ExtendedLandingPagesContext
  )
  const [modalIsOpen, setModalIsOpen] = React.useState(false)
  const [websiteReceivedAttempt, websiteReceivedSetter] = React.useState(0)

  const pages = website?.pages.sort((a, b) => a.index - b.index)

  React.useEffect(() => {
    if (!website) {
      try {
        var data = fetchWebsite(id)
        if (!data.data) {
          console.log('Request to fetch website from component failed.')
          setTimeout(
            () => websiteReceivedSetter(websiteReceivedAttempt + 1),
            5000
          )
        }
      } catch (e) {
        console.log('Caught exception')
        console.log(e)
        setTimeout(
          () => websiteReceivedSetter(websiteReceivedAttempt + 1),
          5000
        )
      }
    }

    if (
      website &&
      match?.params &&
      !website.pages.find(page => page.id === +match.params.pageId)
    ) {
      history.push(`/event/${id}/pages/${website.pages[0]?.id}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [website, websiteReceivedAttempt])

  return (
    <div className="EventPages">
      <div className="Sidebar">
        <div className="SidebarHeader">
          <h1>{t('extendedLandingPages.title')}</h1>
          <Button
            type="primary"
            className="ConfigureButton"
            onClick={() => setModalIsOpen(true)}>
            <ConfigureIcon />
          </Button>
        </div>
        <div className="HorizontalMenu">
          {pages &&
            pages.map(page => (
              <MenuItem key={page.id} to={`/event/${id}/pages/${page.id}`}>
                {page.title}
              </MenuItem>
            ))}
        </div>
      </div>
      <div className="PagesContainer">
        <div className="track">
          {pages && (
            <Switch>
              {pages.map(page => (
                <Route
                  key={page}
                  path={`/event/${id}/pages/${page.id}`}
                  render={() => <ExtendedLandingPage pageId={page.id} />}
                />
              ))}
              <Route
                exact
                path={`/event/${id}/pages`}
                render={() => (
                  <Redirect to={`/event/${id}/pages/${website.pages[0]?.id}`} />
                )}
              />
            </Switch>
          )}
        </div>
      </div>

      {modalIsOpen && (
        <EditExtendedLandingPagesModal
          handleCloseModal={() => setModalIsOpen(false)}
          eventId={id}
        />
      )}
    </div>
  )
}

export default withRouter(EventPages)
